<template>
    <div class="button-bar" style="min-height:25px;">
        <!-- submit button -->
        <button
            v-if="!activeQuestion && !reviewMode || timeLimitExceeded" 
            class="btn btn-light-blue"
            @click="doSubmitTest()">
            <font-awesome-icon icon="arrow-alt-circle-up" />
            {{ $t('MAIN_CONTENT.testButtons.takeTester_submitTest') }}
        
        </button>

        <!-- show flag button only for test taking -->
        <button
            v-if="!timeLimitExceeded && activeQuestion && !reviewMode && !isGraded( activeQuestion )"
            aria-label="Flag Question"
            class="btn btn-violet"
            @click="toggleQuestionFlag()">
            <font-awesome-icon icon="flag" aria-hidden="true" /><span class="hidden-xs"> {{ $t('MAIN_CONTENT.testButtons.takeTester_flagQuestion') }}</span>
        </button>

        <button
            v-if="!isGraded( activeQuestion ) && !timeLimitExceeded && activeQuestion && !reviewMode && testPreview.TEST.STUDENT_IMMEDIATE_FEEDBACK"
            aria-label="Save Answer"
            class="btn "
            :class="getButtonClass( 'save' )"
            :disabled="!getCanChangeAnswer()"
            @click="saveAnswer()">
            <font-awesome-icon icon="save" aria-hidden="true" />
            {{ $t('MAIN_CONTENT.testButtons.takeTester_saveAnswer') }}
        </button>

        <button
            v-else-if="!timeLimitExceeded && !reviewMode && testPreview.TEST.STUDENT_IMMEDIATE_FEEDBACK && activeQuestion && getCanChangeAnswer() && [ 'M','S','N','E' ].indexOf( activeQuestion.QUESTION_TYPE ) > -1"
            aria-label="Change Answer"
            :class="getButtonClass( 'save' )"
            @click="changeAnswer()">
            {{ $t('MAIN_CONTENT.testButtons.takeTester_changeAnswer') }}
        </button>

        <div class="float-right">
            <button
                v-if="!timeLimitExceeded" 
                aria-label="Previous Question"
                class="btn float-left"
                :class="getButtonClass( 'prev' )"
                :disabled="activeQuestionIndex == 0"
                @click="previousQuestion()">
                <i class="fas fa-arrow-circle-left" aria-hidden="true"></i> <span class="hidden-xs">{{ $t('MAIN_CONTENT.commonContent.previous') }}</span>
            </button>
            
            <button 
                v-if="!timeLimitExceeded && activeQuestion" 
                ref="next"
                aria-label="Next Question"
                :class="getButtonClass( 'next' )"
                @click="nextQuestion()"
                class="btn float-left">
                <span class="hidden-xs">{{ $t('MAIN_CONTENT.commonContent.next') }}</span> 
                <font-awesome-icon icon="arrow-circle-right" aria-hidden="true" />
            </button>
            

        </div>
    </div>
</template>
<script>
import { mapState,mapActions,mapMutations,mapGetters } from "vuex";
export default{
    props: {
        display: {
            type    : Boolean,
            default : true
        }
    },
    computed: {
        ...mapState( {
            testPreview: state =>{
                return state.testTaker.testPreview;
            },
            activeQuestion: state =>{
                return state.testTaker.activeQuestion;
            },
            testMode: state =>{
                return state.testTaker.testMode;
            },
            // object of all answered questions, keyed by questionID
            studentAnswers: state =>{
                return state.testTaker.testPreview.STUDENT_ATTEMPT.ANSWERS;
            },
            reviewMode: state =>{
                return state.testTaker.reviewMode;
            },
            timeLimitExceeded: state =>{
                return state.testTaker.timeLimitExceeded;
            }
        } ),
        ...mapGetters( [ "primaryQuestions" ] ),
        isImmediateFeedback (){
            return this.testPreview.TEST.STUDENT_IMMEDIATE_FEEDBACK;
        },
        allowChanges(){
            return this.testPreview.TEST.STUDENT_IMMEDIATE_FEEDBACK && this.testPreview.TEST.ALLOW_ANSWER_CHANGE;
        },
        activeQuestionIndex (){
            if( ! this.activeQuestion ) return -1;
            return this.primaryQuestions.map( q=>{
                return q.TEST_QUESTION_RID; 
            } ).indexOf( this.activeQuestion.TEST_QUESTION_RID );
        },
        isProxyMode(){
            return this.testMode === "proxy";
        }
    },
        
    methods: {
        ...mapActions( [ "nextQuestion","previousQuestion","submitTest" ] ),
        ...mapMutations( [ "toggleQuestionFlag" ] ),
        getCanChangeAnswer(){
            return ( this.allowChanges || !this.isGraded( this.activeQuestion ) ) ? true : false;
        },
        changeAnswer(){
            this.studentAnswers[ this.activeQuestion.TEST_QUESTION_RID ].forEach(element => {
                element.QUESTION_GRADED_STATUS = "";
            });
        },
        getButtonClass ( btn ){
            if( btn === "save" ){
                return ( this.isImmediateFeedback && !this.isGraded( this.activeQuestion ) ) || this.allowChanges ? "btn btn-success" : "btn btn-unstyled" ;
            }
            if( btn === "next" ){
                return this.isGraded( this.activeQuestion ) ? "btn btn-success" : "btn btn-link";
            }
            if( btn === "prev" ){
                return this.isImmediateFeedback && !this.isGraded( this.activeQuestion ) ? "btn btn-unstyled" : "btn btn-link";
            }
            return "btn";

        },
        // returns true if question has been graded
        isGraded ( answer ){
            if( !answer ) return false;
            return Object.prototype.hasOwnProperty.call( this.studentAnswers, answer.TEST_QUESTION_RID ) 
                    && this.studentAnswers[ answer.TEST_QUESTION_RID ].filter( ans =>{
                        return ans.QUESTION_GRADED_STATUS; 
                    } ).length > 0;
        },
        isFinishedGrading ( answer ){
            if( !answer ) return false;
            return this.testPreview.TEST.TEST_GRADED_STATUS === 'Y';
        },
        saveAnswer (){
            this.$emit( "answer-save", true );
        },
        doSubmitTest (){
            this.$emit( "test-submitted" );
        }
    }
};
</script>
